import {
  GET_SHIPPING_TABLE_DATA,
  GET_SHIP_TO_PARTY_DATA,
  SAVE_DATA,
  SET_SHIPPING_TABLE_STATUS,
} from '../helpers/types';

const INITIAL_STATE = {
  shippingDataArr: [],
  isLoading: false,
  shipToPartyDataArr: [],
  priceData: [],
  orderId: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SHIPPING_TABLE_DATA:
      return {
        ...state,
        shippingDataArr: action.payload.data,
        priceData: action.payload.priceData,
        isLoading: false,
      };
    case SET_SHIPPING_TABLE_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case SAVE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case GET_SHIP_TO_PARTY_DATA:
      return {
        ...state,
        shipToPartyDataArr: action.payload.data,
        isLoading: false,
      };
    default:
      return state;
  }
};
